/**
 * Account code constants used across the application.
 * Centralizes magic values to prevent inconsistencies.
 */

/** The COA code used for uncategorized/unmatched transactions */
export const UNCATEGORIZED_CODE = '9970';

/** Display name for the uncategorized account */
export const UNCATEGORIZED_NAME = 'Uncategorized';
